import { getMetadata, getResource } from '@hcengineering/platform'
import uiPlugin, { getCurrentLocation, parseLocation, type Location } from '@hcengineering/ui'
import view from '@hcengineering/view'
import plugin from './plugin'

const workbenchRoute = 'workbench'
export const reportsAlias = 'reports'

const reportsImagePattern = /\.(png|jpe?g|gif|webp|svg|avif)$/i

export function isReportsImage (name: string): boolean {
  return reportsImagePattern.test(name)
}

export function getAppLocation (href: string): Location | undefined {
  try {
    const url = new URL(href, window.location.href)
    const frontUrl = getMetadata(plugin.metadata.FrontUrl) ?? window.location.origin
    if (url.origin !== frontUrl) return undefined
    const loc = parseLocation(url)
    if (loc.path[0] === reportsAlias) return getReportsTabLocation(loc)
    const routes = getMetadata(uiPlugin.metadata.Routes)
    return routes?.get(loc.path[0]) !== undefined ? loc : undefined
  } catch {
    return undefined
  }
}

function getReportsTabLocation (loc: Location): Location | undefined {
  const current = getCurrentLocation()
  if (current.path[0] !== workbenchRoute || current.path[1] === undefined) return undefined
  const path = loc.path.slice(1).filter((it) => it !== '')
  if (path.length === 0) return undefined
  return { path: [workbenchRoute, current.path[1], reportsAlias, ...path], fragment: loc.fragment }
}

export function opensAsWorkbenchTab (loc: Location): boolean {
  const current = getCurrentLocation()
  return loc.path[0] === workbenchRoute && current.path[0] === workbenchRoute && loc.path[1] === current.path[1]
}

export function getWorkbenchTabLocation (href: string): Location | undefined {
  const loc = getAppLocation(href)
  return loc !== undefined && opensAsWorkbenchTab(loc) ? loc : undefined
}

export function opensInBackground (event?: MouseEvent): boolean {
  return event !== undefined && (event.ctrlKey || event.metaKey)
}

export async function openAppLocationInNewTab (loc: Location, event?: MouseEvent): Promise<void> {
  const openInNewTab = await getResource(view.function.OpenLocationInNewTab)
  await openInNewTab(loc, !opensInBackground(event))
}
